var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g, _path49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteSignLeft1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 457,
    viewBox: "0 0 298 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.77 415.54C163.77 415.54 191.93 402.43 197.8 394.75C199.77 387.55 177.78 392.56 177.78 392.56L163.77 415.54Z",
    fill: "#D6B991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.94 323.2C218.94 323.2 213.68 314.91 187.33 321.92C177.63 328.94 190.63 339.97 190.63 339.97L218.94 323.2Z",
    fill: "#C09868"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.792 352.357L190.605 351.758L188.969 390.463L203.157 391.063L204.792 352.357Z",
    fill: "#C09868"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.75 351.59C214.75 351.59 210.35 346.51 198.74 346.23C195.28 352.29 198.16 357.12 198.16 357.12L214.75 351.59Z",
    fill: "#C09868"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.73 337.29C182.09 339.9 176.96 343.73 176.96 343.73L193.69 389.21L163.78 415.55C163.78 415.55 134.52 427.47 116.19 414.14C106.91 390.86 109.66 357.59 109.66 357.59C109.66 357.59 153.42 331.2 161.05 327.92C168.69 324.64 170.47 322.87 190.37 321.43",
    fill: "#D6B991"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.26 358.38C193.05 363.61 188.46 367.88 183.58 371.59C171.31 380.91 156 386.06 140.64 386.56C137.6 386.68 134.52 386.43 131.49 386.23C133 385.94 134.49 385.69 135.99 385.46C140.26 384.84 145.03 383.89 149.21 382.81C166.48 378.5 183.04 370.5 196.26 358.39V358.38Z",
    fill: "#D6B991"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.332 235.12L169.217 236.234L177.628 425.857L202.744 424.743L194.332 235.12Z",
    fill: "#F2C744"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M194.49 238.34L194.9 247.63C184.14 247.95 172.48 250.82 170.25 259.27L169.37 239.45L194.49 238.33V238.34Z",
    fill: "#F2C744"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175.9 243.24C243.069 243.24 297.52 188.789 297.52 121.62C297.52 54.4511 243.069 0 175.9 0C108.731 0 54.28 54.4511 54.28 121.62C54.28 188.789 108.731 243.24 175.9 243.24Z",
    fill: "#F2C744"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M276.35 65.1299C279.88 71.3999 282.84 78.0399 285.17 84.9799",
    stroke: "#F2C744",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.58 6.52C209.34 4.73 244.51 22.3 266.72 50.7",
    stroke: "#F2C744",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175.9 229.97C235.74 229.97 284.25 181.46 284.25 121.62C284.25 61.78 235.74 13.27 175.9 13.27C116.06 13.27 67.55 61.78 67.55 121.62C67.55 181.46 116.06 229.97 175.9 229.97Z",
    fill: "#F2C744"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M175.9 223.38C232.101 223.38 277.66 177.821 277.66 121.62C277.66 65.4196 232.101 19.8601 175.9 19.8601C119.7 19.8601 74.14 65.4196 74.14 121.62C74.14 177.821 119.7 223.38 175.9 223.38Z",
    fill: "#F3F4F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.48 54.9399L175.14 69.8599L170.54 70.0599L156.51 117.06L139.81 117.8L121.67 72.2299L117.07 72.4299L116.41 57.5099L139.28 56.4899L139.94 71.4099L137.87 71.4999L147.29 97.9899L154.32 70.7699L152.25 70.8599L151.59 55.9399L174.46 54.9199L174.48 54.9399Z",
    fill: "#265CA9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M227.34 61.25L229.29 105.16L220.88 114.2L192.88 115.44L183.7 107.19L181.75 63.28L190.16 54.24L218.16 53L227.34 61.25Z",
    fill: "#CD2027"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M123.05 129.39L176.22 127.03L177.23 149.67L162.16 150.34L161.82 142.61L157.84 142.79L159.24 174.23L163.07 174.06L163.73 188.9L141.01 189.91L140.35 175.07L144.18 174.9L142.78 143.46L138.8 143.64L139.14 151.37L124.07 152.04L123.06 129.4L123.05 129.39Z",
    fill: "#CD2027"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M218.76 147.83L218.42 140.1L202.58 140.8L202.95 149.06L216.03 148.48L216.69 163.32L203.61 163.9L203.98 172.24L219.43 171.55L219.09 163.9L234.31 163.22L235.31 185.71L185.97 187.9L185.31 173.06L189.14 172.89L187.74 141.45L183.91 141.62L183.25 126.7L214.77 125.3L217.88 128L217.75 125.17L232.59 124.51L233.6 147.15L218.76 147.81V147.83Z",
    fill: "#265CA9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M204.71 65.9099L206.98 71.9699L213.45 71.6899L208.38 75.7199L210.66 81.7899L205.25 78.2199L200.18 82.2499L201.91 76.0099L196.51 72.4399L202.98 72.1499L204.71 65.9099Z",
    fill: "#F3F4F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M205.62 86.4199L207.89 92.4799L214.36 92.1999L209.29 96.2299L211.57 102.3L206.16 98.7299L201.1 102.76L202.82 96.5199L197.42 92.9499L203.89 92.6599L205.62 86.4199Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M188.73 258.42L194.03 373.29",
    stroke: "#F2C744",
    strokeWidth: 4.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M194.73 388.28L195.27 400.09",
    stroke: "#F2C744",
    strokeWidth: 4.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-35.07 377.49C-33.42 374.92 73.07 371.8 109.66 357.59C135.6 345.31 116.19 414.14 116.19 414.14C116.19 414.14 -0.850006 441.28 -22 451.87C-34.71 422.39 -35.06 377.49 -35.06 377.49H-35.07Z",
    fill: "#D6B991"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.12 389.38C64.02 390.39 72.09 386.48 80.7 385.31C84.96 384.61 89.37 384.17 93.6 383.55C97.7 382.85 102.02 381.47 103.74 377.26C103.64 378.36 103.29 379.46 102.69 380.46C98.51 386.88 87.97 387 81.19 388.43C72.61 389.54 63.51 392.92 55.11 389.39L55.12 389.38Z",
    fill: "#D6B991"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.42 401.97C59.61 397.95 64.41 396.1 68.57 394.88C72.8 393.65 77.07 392.6 81.38 391.74C85.71 390.88 90 390.19 94.44 389.72C97.74 389.35 101.95 389.88 104.13 392.83C104.84 393.77 105.28 394.91 105.25 396.02C104.59 393.87 102.72 392.57 100.82 392.05C98.9 391.52 96.84 391.76 94.78 392.15C90.58 393.04 86.26 393.99 82 394.82C77.73 395.68 73.43 396.48 69.14 397.25C64.92 398.05 60.64 398.87 57.42 401.97Z",
    fill: "#D6B991"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M200.23 351.67C201.41 350.99 202.8 350.71 204.16 350.4C207.56 349.63 212.48 348.97 215.07 351.92C215.72 352.66 216.13 353.58 216.35 354.53C216.47 355.05 216.53 355.59 216.53 356.12C216.5 358.97 214.55 361.25 212.36 362.85C209.64 364.84 206.37 366.21 203.12 367.06C202.75 367.16 202.43 367.22 202.04 367.15C201.45 367.04 200.93 366.68 200.53 366.23C199.75 365.37 199.08 364.21 198.55 363.18C197.98 362.09 197.55 360.93 197.3 359.72C196.84 357.46 197.28 354.84 198.7 352.99C199.14 352.42 199.67 351.99 200.24 351.65L200.23 351.67Z",
    fill: "#D6B991"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M200.58 354.45C200.58 354.45 198.8 360.22 202.45 364.96C208.19 363.59 208.7 363.04 208.7 363.04C209.42 361.82 208.09 355.11 206.88 354.58C203.87 354.19 200.59 354.46 200.59 354.46L200.58 354.45Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M210.16 353.52C212.77 354.95 214.07 358.84 212.1 361.28C210.57 358.85 209.63 356.41 210.16 353.52Z",
    fill: "#D6B991"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M196.81 328.34C197.85 327.47 199.17 326.95 200.45 326.4C203.66 325.04 215.86 320.74 218.94 323.19C219.71 323.8 220.27 324.63 220.66 325.54C220.87 326.03 221.02 326.55 221.11 327.08C221.58 329.89 220.06 332.48 218.19 334.44C215.86 336.88 205.4 341.59 202.36 343C202.01 343.16 201.71 343.28 201.31 343.28C200.71 343.28 200.13 343.01 199.66 342.64C198.74 341.93 197.88 340.91 197.17 339.99C196.42 339.02 195.79 337.95 195.33 336.8C194.48 334.65 194.45 332 195.53 329.93C195.86 329.29 196.3 328.77 196.82 328.34H196.81Z",
    fill: "#D6B991"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M197.65 331.03C197.65 331.03 196.92 337.02 201.33 341.05C206.74 338.69 207.14 338.06 207.14 338.06C207.63 336.74 205.15 330.36 203.86 330.05C200.83 330.2 197.64 331.03 197.64 331.03H197.65Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M206.91 328.42C209.73 329.37 211.69 332.97 210.18 335.72C208.25 333.6 206.89 331.36 206.91 328.42Z",
    fill: "#D6B991"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M211.42 325.97C214.24 326.92 216.2 330.52 214.69 333.27C212.76 331.15 211.4 328.91 211.42 325.97Z",
    fill: "#D6B991"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M200.31 367.83C200.59 367.58 200.9 367.37 201.27 367.21C201.95 366.92 202.65 366.63 203.35 366.38C204.99 365.79 206.71 365.34 208.46 365.25C212.07 365.07 214.93 366.85 215.93 370.4C217.09 374.51 214.51 377.68 211.06 379.55C209.65 380.31 208.15 380.89 206.62 381.36C205.44 381.72 204.16 382.25 202.9 382.05C201.66 381.86 200.87 381.22 200.22 380.21C199.68 379.37 199.21 378.48 198.86 377.54C197.97 375.19 197.88 372.62 198.81 370.27C199.18 369.35 199.61 368.46 200.32 367.82L200.31 367.83Z",
    fill: "#D6B991"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M201.7 369.89C201.7 369.89 199.98 375.36 203.16 379.72C207.3 378.85 208.43 378.33 208.43 378.33C208.9 376.69 207.21 371.36 206.34 369.73C204.22 369.37 201.69 369.89 201.69 369.89H201.7Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M208.49 368.48C211.74 369.95 213.09 374.49 211.06 377.5C209.53 374.56 208.74 371.78 208.49 368.48Z",
    fill: "#D6B991"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M201.43 394.53C201.43 394.53 197.31 395.01 197.33 388.47C197.35 381.93 203.14 381.84 203.14 381.84C203.14 381.84 206.57 381.92 206.12 388C205.66 394.07 201.43 394.53 201.43 394.53Z",
    fill: "#D6B991"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M201.09 384.35C200.42 384.44 199.6 386.31 199.47 386.72C198.9 388.41 199.16 390.23 199.82 391.85C199.99 392.28 200.23 393.29 200.84 393.22C201.29 393.17 201.6 392.41 201.75 392.04C201.95 391.57 202.07 391.06 202.18 390.56C202.52 389.02 202.63 387.25 202.12 385.73C201.98 385.3 201.71 384.66 201.32 384.41C201.25 384.36 201.17 384.35 201.09 384.36V384.35Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M204.08 384.06C206.23 386.36 206.11 390.81 203.31 392.55C203.67 389.52 203.57 387.17 204.08 384.06Z",
    fill: "#D6B991"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M100.11 423.94C26.51 442.31 -49.1 451.35 -124.96 450.85C-124.8 427.42 -124.65 404 -124.49 380.57C-54.53 381.04 15.2101 372.7 83.09 355.75C88.76 378.48 94.44 401.21 100.11 423.93V423.94Z",
    fill: "#E2E2E2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M91.47 432.26C20.57 449.1 -52.11 457.37 -125 456.89C-124.82 429.44 -124.63 401.98 -124.45 374.53C-58.15 374.97 7.95001 367.45 72.44 352.13C78.79 378.84 85.13 405.55 91.48 432.26H91.47Z",
    fill: "#265CA9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60.54 373.38C57.55 374.03 54.63 372.17 54.02 369.26C53.41 366.34 55.31 363.48 58.25 362.84C61.19 362.2 64.11 364.02 64.76 366.93C65.41 369.84 63.53 372.74 60.54 373.38Z",
    fill: "#64A3E2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M58.57 366.71C58.7 367.32 58.31 367.92 57.69 368.05C57.07 368.18 56.47 367.8 56.34 367.19C56.21 366.58 56.61 365.99 57.22 365.85C57.84 365.72 58.44 366.1 58.57 366.71Z",
    fill: "#124875"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8 366C61.93 366.61 61.5399 367.21 60.9199 367.34C60.2999 367.47 59.6999 367.09 59.5599 366.49C59.4299 365.88 59.82 365.28 60.44 365.15C61.06 365.02 61.66 365.4 61.8 366Z",
    fill: "#124875"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M59.22 369.71C59.35 370.32 58.96 370.92 58.34 371.05C57.72 371.18 57.11 370.8 56.98 370.19C56.85 369.58 57.25 368.98 57.86 368.85C58.48 368.72 59.09 369.1 59.22 369.71Z",
    fill: "#124875"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M62.46 369.01C62.59 369.62 62.2 370.22 61.58 370.35C60.96 370.49 60.35 370.1 60.22 369.5C60.09 368.89 60.48 368.29 61.1 368.16C61.72 368.02 62.33 368.41 62.46 369.01Z",
    fill: "#124875"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M109.66 357.59C109.66 357.59 114.56 329.69 140.28 312.17C153.35 302.28 158.61 287.39 158.88 285.35C159.17 283.14 164.41 275.98 168.98 279.45C173.55 282.91 172.52 290.49 172.48 292.43C172.44 294.37 166.71 312.94 154.87 327.25C146.72 338.9 147.18 346.07 147.18 346.07C147.18 346.07 135.07 362.53 109.67 357.6L109.66 357.59Z",
    fill: "#D6B991"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M135.19 315.98C138.92 315.77 143.61 318.3 144.22 322.24C140.96 320.59 137.51 318.95 135.19 315.98Z",
    fill: "#D6B991"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M129.07 321.63C132.08 321.36 135.92 323.62 136.05 326.87C133.17 325.8 130.55 324.47 129.07 321.63Z",
    fill: "#D6B991"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1670_19104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 278,
    width: 64,
    height: 81
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M109.66 357.59C109.66 357.59 114.56 329.69 140.28 312.17C153.35 302.28 158.61 287.39 158.88 285.35C159.17 283.14 164.41 275.98 168.98 279.45C173.55 282.91 172.52 290.49 172.48 292.43C172.44 294.37 166.71 312.94 154.87 327.25C146.72 338.9 147.18 346.07 147.18 346.07C147.18 346.07 135.07 362.53 109.67 357.6L109.66 357.59Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1670_19104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.22 281.36C161.22 281.36 164.83 284.66 163.04 291.35C161.25 298.04 160.62 298.07 160.62 298.07L154.91 294.14C154.91 294.14 155.51 283.05 161.22 281.36Z",
    fill: "#CFABA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M151.21 333.14C151.98 345.43 140.7 356.46 129.39 359.35C130.46 358.24 131.6 357.31 132.7 356.34C140.21 349.71 147.18 342.51 151.22 333.15L151.21 333.14Z",
    fill: "#D6B991"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteSignLeft1);
export default __webpack_public_path__ + "static/media/VoteSignLeft1.7f5791ee04d0d033ff68112cdf7d19dc.svg";
export { ForwardRef as ReactComponent };